import React from "react";
import NavBar from "../../component/Common/Navbar";
import Technology from "../../component/FooterPage/Technology";
import CallMe from "../../component/Common/CallMe";
import FooterCloud from "../../component/LandingPage/Footer";
import Head from "next/head";
const TechnologyPage = () => {
  return (
    <div>
      {/* <NavBar/> */}
      <Head>
        <title>Teknologi - CloudBank</title>
        <link rel="canonical" href="https://www.cloudbank.id/technology" />
      </Head>

      <div className="d-flex flex-column my-5">
        <Technology />
        <CallMe />
      </div>
      <FooterCloud />
    </div>
  );
};

export default TechnologyPage;
